<template>
  <div class ="sales-chart__chart-container">
    <h3>MFG MIX</h3>
    <ChartLoader v-if="loaders.mixVendor"></ChartLoader>
    <div class="css-grid sales-chart__chart-wrapper" v-else>
      <div class="sales-chart__chart-legend">
        <table class="pieTable">
          <tr>
              <th class="pieTable__header pieTable__header--key" colspan="2">MFG</th>
              <th class="pieTable__header pieTable__header--value">Units Sold</th>
          </tr>
          <tbody v-if="contents.mixVendor">
          <tr v-bind:key="index" v-for="(vendor, index) in contents.mixVendor">
              <td class="chartColor"><div class="chartColor__box" v-bind:class="`chartColor__box--${ucFirst(vendor.vendor)}`">&nbsp;</div></td>
              <td class="pieTable__key">{{ ucFirst(vendor.vendor) }}</td>
              <td class="pieTable__value">{{ currency(vendor.units) }}</td>
          </tr>
          </tbody>
        </table>
      </div>

      <div class="sales-chart__chart h-center-align">
          <ChartCustom :chart-settings="chartConfig" :allow-resize="false" :dimensions="chartConfig.size" class="chart__mix"></ChartCustom>
      </div>
    </div>
  </div>
</template>



<script>
  import lodash from 'lodash';
  import { mapGetters } from 'vuex';
  import ChartCustom from '../../general/ChartCustom.vue';
  import ChartLoader from './ChartLoader.vue';
  import DataMethods from '../../utils/DataMethods';


  //////////////////////////////////////
  // Vue Object
  //////////////////////////////////////
  export default {
    name: 'ChartMixVendor',
    components: {
      ChartCustom,
      ChartLoader,
    },
    mixins: [DataMethods],
    computed: {
      ...mapGetters('purchaseActivity', ['contents', 'loaders', 'initializers']),
      chartConfig() {
        return {
          size: {
              width: 150,
              height: 150
          },
          data: {
            json: this.formattedData,
            colors: {
                oticon: '#D50D8C',
                phonak: '#7FC241',
                resound: '#D71921',
                widex: '#87693C',
                unitron: '#00CCFF',
                sonic: '#415968',
                signia: '#A12223'
            },
            type : 'donut',
            empty: { label: { text: 'No data available' }},
          },
          legend: {
            show: false,
            position: 'right',
          },
          donut: {
              width: 48
          },
        };
      },
      formattedData() {
        const data = {}
        // Create data object
        lodash.map(this.contents.mixVendor, (vendor) => {
          data[vendor.vendor] = vendor.units;
        })
        return data;
      }
    },
  }
</script>

<style lang="scss" scoped>
.chartColor {
  @include e(box) {
    width: 11px;
    height: 11px;
    border-radius: 100%;
    border: none;

    @include m(Oticon) {
        background: $color-vendor-oticon;
    }

    @include m(Phonak) {
        background: $color-vendor-phonak;
    }

    @include m(Resound) {
        background: $color-vendor-resound;
    }

    @include m(Widex) {
        background: $color-vendor-widex;
    }

    @include m(Unitron) {
        background: $color-vendor-unitron;
    }

    @include m(Sonic) {
        background: $color-vendor-sonic;
    }

    @include m(Signia) {
        background: $color-vendor-signia;
    }
  }
}

.mix {
  @include e('chart') {
    h3 {
      font-weight: 600;
      font-size: em(20px);
    }
  }
}

.chart {
  @include e('wrapper') {
    padding: 15px 0px 15px 15px;
    @include breakpoint($x-small) {
      padding: em(10px) 0 em(10px) 0;
    }
    @include breakpoint($small) {
      padding: em(10px) 0 em(10px) 0;
    }
    h3 {
      font-family: $font-family--primary;
      color: $east-bay;
      font-size: em(16px);
      margin-bottom: 18px;
    }
  }
}

.pieTable {
  width: 100%;

  @include e('header') {
    color: $dove-grey;
    font-weight: 600;
    font-size: em(14px);

    @include m('value') {
      text-align: right;
    }
  }

  @include e('key') {
    color: $dove-grey;
  }

  .pieTable__value {
    text-align: right;
    color: $dove-grey;
    font-weight: 600;
  }

  tbody {
    border-top: 1px solid $mystic;
  }

  tbody:before {
    content: '';
    display: block;
    height: 5px;
  }

  th {
    font-weight: 500;
    padding-bottom: 5px;
  }

  td {
    text-align: left;
    padding: 4px;
  }

  .chartColor {
    width: 22px;
  }
}
</style>
